export const redSocialModel = {
  rs: null,
  dr: null,
  vr: null,
  lr: null,
  ap: false,
};
